// services/SensorServiceFactory.js
import { trackpacSensorService } from "./trackpacsensor.service";
import { loraSensorService } from "./lorasensors.service";
import { dynamoSensorService } from "./dynamosensor.service";
import { kineticSolutionsSensorService } from "./kineticsolutionssensor.service";
import Base from "antd/lib/typography/Base";
import { traccarSensorService } from "./traccarsensor.service";

class BaseSensorService {
  async getDeviceList() {
    throw new Error('getDeviceList method must be implemented');
  }
}

class TrackpacSensorServiceAdapter extends BaseSensorService {
  async getDeviceList() {
    const res = await trackpacSensorService.getSensorList();
    return res;
  }
}

class LoraSensorServiceAdapter extends BaseSensorService {
  async getDeviceList() {
    const res = await loraSensorService.getSensorList();
    return res;
  }
}

class TraccarSensorServiceAdaptor extends BaseSensorService {
  async getDeviceList() {
    const res = await traccarSensorService.getSensorList();
    return res;
  }
}

class KineticSolutionsSensorServiceAdapter extends BaseSensorService {
  async getDeviceList() {
    const res = await kineticSolutionsSensorService.getSensorList();
    return res;
  }
}

class DynamoSensorServiceAdapter extends BaseSensorService {
  constructor(supplier) {
    super();
    this.supplier = supplier;
  }

  async getDeviceList() {
    const res = await dynamoSensorService.getUniqueSensorsBySupplier(this.supplier);
    return res;
  }
}

export class SensorServiceFactory {
  static createService(supplier) {
    switch (supplier) {
      case 'Trackpac':
        return new TrackpacSensorServiceAdapter();
      case 'Lora AirAgri':
        return new LoraSensorServiceAdapter();
      case 'RF Technology':
        return new DynamoSensorServiceAdapter(supplier);
      case 'Traccar AirAgri':
        return new TraccarSensorServiceAdaptor();
      case 'Kinetic Solutions':
        return new KineticSolutionsSensorServiceAdapter();
      default:
        throw new Error(`Unsupported supplier: ${supplier}`);
    }
  }
}
